module.exports = __webpack_public_path__ + "img/hero.78e08996.webp";